var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-absolute pipeFlowDirection"},[(_vm.showProgress)?_c('PlayerProgress',{attrs:{"loadType":_vm.loadType,"percentage":_vm.loadPercentage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }